var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle01Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0033 16.3114C30.0033 15.1603 29.908 14.3203 29.7018 13.4492H16.2891V18.6447H24.162C24.0033 19.9359 23.1462 21.8803 21.2414 23.1869L21.2147 23.3609L25.4555 26.5805L25.7494 26.6092C28.4477 24.167 30.0033 20.5736 30.0033 16.3114Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2853 30.0008C20.1424 30.0008 23.3804 28.7562 25.7456 26.6096L21.2377 23.1873C20.0313 24.0117 18.4123 24.5873 16.2853 24.5873C12.5076 24.5873 9.30128 22.1451 8.15832 18.7695L7.99078 18.7835L3.58111 22.128L3.52344 22.2851C5.87261 26.8584 10.698 30.0008 16.2853 30.0008Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15866 18.7699C7.85708 17.8988 7.68255 16.9654 7.68255 16.001C7.68255 15.0365 7.85708 14.1032 8.1428 13.2321L8.13481 13.0466L3.66986 9.64844L3.52377 9.71653C2.55556 11.6143 2 13.7455 2 16.001C2 18.2566 2.55556 20.3876 3.52377 22.2854L8.15866 18.7699Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2854 7.4133C18.9679 7.4133 20.7774 8.54885 21.8092 9.4978L25.8409 5.64C23.3648 3.38445 20.1425 2 16.2854 2C10.698 2 5.87262 5.1422 3.52344 9.71549L8.14247 13.2311C9.30131 9.85555 12.5076 7.4133 16.2854 7.4133Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle01Svg);
export default __webpack_public_path__ + "static/media/google-01.svg.0ea7dec3d14a5d2ef134383e7918dd8b.svg";
export { ForwardRef as ReactComponent };